import { getPromptActionActivityFeedItem } from '../utils/ActivityFeedHelpers';
import { getFeedActionCallback } from '../store/feedActionSelector';
import { logUsage } from 'owa-analytics';
import type { ActivityFeedItem } from '../service/ActivityFeedItem';
import { dismissPromptActionCard } from './dismissPromptActionCard';

export function getPromptFeedActionCard(id: string): ActivityFeedItem {
    logUsage('getPromptFeedActionCard');

    const dismissAction = () => {
        logUsage('promptFeedActionCard_Dismissed');
        dismissPromptActionCard();
    };

    const onClickAction = () => {
        logUsage('promptFeedActionCard_Clicked');
        getFeedActionCallback()();
    };

    return getPromptActionActivityFeedItem(id, onClickAction, dismissAction);
}
